module.exports = __webpack_public_path__ + "img/icon_no_history.dc0c32f2.svg";